module.exports = __webpack_public_path__ + "img/e2.2a33031d.png";